import React from 'react';
import { Row, Col, Button } from 'antd';
import { connect } from 'dva';

@connect(({ operationChargeItemPublishChargeItemSteps }) => ({
  uploadResponse: operationChargeItemPublishChargeItemSteps.step3NotificationUploadResponse,
}))
export default class ErrorInfo extends React.Component {
  constructor(props) {
    super(props);

    this.handleDownloadParseResult = this.handleDownloadParseResult.bind(this);
  }

  handleDownloadParseResult() {
    const { uploadResponse: { excelDownloadUrl } } = this.props;

    window.open(excelDownloadUrl);
  }

  render() {
    const { uploadResponse } = this.props;

    if (uploadResponse.code !== 200) {
      return (
        <Row className="upload-error">
          <Col span={24} className="ant-alert ant-alert-error ant-alert-no-icon">
            <span className="ant-alert-message">
              <div className="line">解析异常：{uploadResponse.msg}</div>
            </span>
          </Col>
        </Row>
      );
    }

    return (
      <Row className="upload-error">
        <Col span={24} className="ant-alert ant-alert-error ant-alert-no-icon">
          <span className="ant-alert-message">
            <div className="line">
              文件中共有{uploadResponse.total}条数据，
              {uploadResponse.validNum}条数据校验成功，
              {uploadResponse.invalidNum}处数据校验失败
            </div>
            <div className="line">
              失败数据已在Excel表格中用底色标识 （<span className="error-color" />与通讯录不符合 或
              未填写/填写错误）
            </div>
            <div className="line">
              请点击
              <Button type="primary" ghost size="small" onClick={this.handleDownloadParseResult}>
                数据解析结果
              </Button>
              下载表格，并根据错误提示，在本地修改表格信息后重新上传
            </div>
          </span>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step3-Notification/UploadExcel/ErrorInfo.js